/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Focus_DescInputs */

const en_lg_focus_desc = /** @type {(inputs: Lg_Focus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow shared focus and break cycles. Nearby audio respects distance and room access; your microphone starts only when you choose.`)
};

const id_lg_focus_desc = /** @type {(inputs: Lg_Focus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti siklus fokus dan istirahat bersama. Audio sekitar mengikuti jarak dan izin ruang; mikrofon menyala hanya saat kamu memilihnya.`)
};

/**
* | output |
* | --- |
* | "Follow shared focus and break cycles. Nearby audio respects distance and room access; your microphone starts only when you choose." |
*
* @param {Lg_Focus_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_focus_desc = /** @type {((inputs?: Lg_Focus_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Focus_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_focus_desc(inputs)
	return en_lg_focus_desc(inputs)
});